export class EntPositionFilter {
    page: number = 1;
    size: number = 30;
    name: string | null = null;
    departmentIds: number[] | null = null;
    governmentId: number | null = null;
    createdFrom: string | null = null;
    createdTo: string | null = null;
    deleted: boolean = false;
}
